import i18n from '@/i18n/config';
export var subscriptionTierMap = new Map([
    ['enterprise', i18n.t('global.subscriptions.enterprise')],
    ['premium', i18n.t('global.subscriptions.premium')],
    ['legacy', i18n.t('global.subscriptions.legacy')],
    ['', i18n.t('global.subscriptions.unassigned')],
]);
